import { Routes } from '@angular/router';
import { adminAuthGuard } from './core/auth/auth.guard';
import { MainLayoutComponent } from './core/layout/main-layout.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./core/features/login/login.component').then(
        m => m.LoginComponent
      ),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [adminAuthGuard],
    children: [
      { path: '', redirectTo: 'care-homes', pathMatch: 'full' },
      {
        path: 'care-homes',
        loadComponent: () =>
          import('./core/features/care-homes/care-homes-list.component').then(
            m => m.CareHomesListComponent
          ),
      },
      {
        path: 'care-homes/:careHomeId/workers',
        loadComponent: () =>
          import('./core/features/workers/workers-list.component').then(
            m => m.WorkersListComponent
          ),
      },
      {
        path: 'care-homes/:careHomeId/clients',
        loadComponent: () =>
          import('./core/features/clients/clients-list.component').then(
            m => m.ClientsListComponent
          ),
      },
      {
        path: 'care-homes/:careHomeId/clients/:clientId',
        loadComponent: () =>
          import('./core/features/clients/client-detail.component').then(
            m => m.ClientDetailComponent
          ),
      },
      {
        path: 'cron-jobs',
        loadComponent: () =>
          import('./core/features/cron-jobs/cron-jobs-list.component').then(
            m => m.CronJobsListComponent
          ),
      },
      { path: '**', redirectTo: 'care-homes' },
    ],
  },
  { path: '**', redirectTo: '' },
];